import _ from 'lodash';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { pick } from 'lodash/fp';

import PageContainer from './PageContainer';
import mockTemplates from './__mocks__/templates.json';
import session from '../models/Session';


export default class JamParentSelectContainer extends PageContainer {
  state = {
    currentStep: 1,
    selectedParents: [],
    openDrawer: false,
    cardInfo: '',
    template: (mockTemplates || []).filter(t => /Character/i.test(t.name)).pop(),
    currentRequirement: null,
    errors: []
  };

  options = {
    getFromSession: ['template', 'selectedParents'],
    allowedPresetTypes: ['Premise', 'Genre', 'Topic', 'Archetype'],
  }

  subscriptions = []

  constructor(props) {
    super(props);

    this.remainingRequirements = null;
  }

  async setup(props) {
    session.clearSessionsExceptUserSession();
    await session.save();
    session.selectTemplate(props.template);
    await this.subscribeToSession();
    await this.checkRequirements();
  }

  destroy() {
    this.unsubscribeAll();
  }

  // if parent matches any requirement
  async isValidParent(parent) {
    console.log('before the remaining requirement')
    if (!this.remainingRequirements) {
      await this.checkRequirements();
    }
    console.log('passes the remaining requirement')
    return _.find(this.remainingRequirements, requirement => this.isMatchRequirement(parent, requirement));
  }

  // check if parent matches requirement, need saeeds help
  isMatchRequirement(parent, requirement) {
    // console.log('Checked isMatchRequirement',  (parent.type === requirement.name.trim()) && (requirement.count > 0), parent, requirement);
    console.log('parent.type === requirement.name', {
      parent, requirement
    });
    
    if (parent.type) {
      return (parent.type === requirement.name) && (requirement.count >= 0);
    }  

    if (parent.__typename === "Story") {
      return (parent.template.name  === requirement.name) && (requirement.count >= 0);
    }
    
    if (this.options.allowedPresetTypes.indexOf(parent.type) >= 0) {
      return (parent.type === requirement.name.trim()) && (requirement.count >= 0);
    }

    return false;
  }

  // Function to reduce the current selected cards to set currentRequirement in state
  // as well as add this.remainingRequirements as an internal value
  async checkRequirements(parent) {
    console.log('this.state.templatethis.state.templatethis.state.template', this.state.template);
    
    if (!this.state.template) {
      await this.getPropsFromSession();
      if (!this.state.template) {
        return null;
      }
    }
    const templateRequirements = _.map(this.state.template.parents, p => { 
      const requirement = _.cloneDeep(p.template || p.preset);
      requirement.count = p.count; 
      if (p.template) {
        requirement.type = "Story";
      } else {
        requirement.type = p.preset.name; 
      }

      return requirement; 
    });

    console.log('jamParentSelectContainer:checkRequirements:templateRequirements', this.state.selectedParents,  templateRequirements);

    this.remainingRequirements = _.reduce(this.state.selectedParents, (requirements, parent) => {
      
      return _.map(requirements, (requirement) => {
        if (this.isMatchRequirement(parent, requirement)) {
          --requirement.count;
        }
        return requirement;
      });
    }, _.cloneDeep(templateRequirements));

    const currentRequirement = _.find(this.remainingRequirements, r => r.count > 0) || _.last(this.remainingRequirements);

    // No more pending requirement, create Draft object
    if (!(currentRequirement && currentRequirement.count > 0)) {
      session.selectCard(this.state.selectedParents);
      session.createDraft();
    }

    return this.setState(state => _.assign(state, { currentRequirement }))
      .then(() => console.log('JamParentSelectContainer:checkRequirements:onComplete', this.state, this.remainingRequirements));
  }

  error(error) {
    return this.setState({
      errors: [error]
    });
  }

  clearErrors() {
    return this.setState({
      errors: []
    });
  }

  // function where to call select parent
  async selectParent(parent) {
    console.log('JamParentSelectContainer:selectParent:selecting parent', parent, this.state.template);

    if (!(await this.isValidParent(parent))) {
      return this.error(new Error('parent selected does not match requirement'));
    }

    if (this.state.currentRequirement) {
      if (!this.isMatchRequirement(parent, this.state.currentRequirement)) {
        return this.error(new Error('parent selected does not match current requirement'));
      }
    }

    return this.setState(state => _.assign(state, { selectedParents: [...state.selectedParents, parent] }))
      .then(() => this.checkRequirements(parent));
  }

  isCardSelected = (props) => {
    if (this.state.selectedParents.filter(({ _id }) => _id === props._id).length) {
      return true;
    }
    return false;
  }

  addSelectedCard(props) {
    console.log('currentRequirement', this.state.currentRequirement);
    
    if (this.state.currentRequirement.count === 0) {
      const lastSelected = _.findLast(this.state.selectedParents, { type: props.type });
      console.log('addSelectedCard:removelastSelected', lastSelected)
      this.removeSelectedCard(lastSelected);
    }
    this.selectParent(props)
      .then(() => session.selectCard(this.state.selectedParents));
    // this.setState(state => ({
    //   selectedParents: [...state.selectedParents, props],
    // }))
    //   .then(() => session.selectCard(this.state.selectedParents));
    // .then(() => console.log('Added selected card', props, this.state));
  }

  removeSelectedCard(props) {
    this.setState(state => ({
      selectedParents: state.selectedParents.filter(card => card._id !== props._id),
      currentRequirement: { ...state.currentRequirement, count: state.currentRequirement.count + 1 },
    }))
      .then(() => console.log('Removed selected card', props, this.state));
  }

  handleClickCard = props => () => {
    this.updateCurrentStep(props);
    console.log('this.state.cardInfo', props);
    if (props.random) {
      console.log('props.randomCardIndex', props.randomCardIndex);
      
      if (_.some(this.state.selectedParents, { randomCardIndex: props.randomCardIndex })) {
        const previousSelectedRandomCard = _.find(this.state.selectedParents, { randomCardIndex: props.randomCardIndex });
        console.log('previousSelectedRandomCard', previousSelectedRandomCard);
        return this.removeSelectedCard(previousSelectedRandomCard);
      }

      if (!this.isCardSelected(props)) {
        this.addSelectedCard(props);
      }
    }

    if (this.isCardSelected(props)) {
      this.removeSelectedCard(props);
    }

    if (!props.random) {
      this.onDrawerOpen(props);
    }

    return this;
  }

  handleCardSelection = () => {
    if (!this.isCardSelected(this.state.cardInfo)) {
      this.addSelectedCard(this.state.cardInfo);
    }
    this.onDrawerClose();
  }

  onDrawerOpen = (props) => {
    this.setState(state => ({
      openDrawer: !state.openDrawer,
      cardInfo: props,
    }));
  }

  onDrawerClose = () => {
    this.setState(() => ({
      openDrawer: false,
    }));
  };

  updateCurrentStep(props) {
    if (props.step && props.step.length > 1) {
      if (this.state.currentStep === 2 || this.isCardSelected(props)) {
        this.setState({
          currentStep: 1,
        });
      } else {
        this.setState({
          currentStep: 2,
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/JamParentSelectContainer.js